import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";

export const Lightbox = ({ open, onOpenChange, items, idx, go }) => {
  const item = items[idx];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-lenis-prevent className="h-[100svh] max-w-none gap-0 rounded-none border-0 bg-white p-0 sm:rounded-none" data-testid="pdp-lightbox">
        <DialogTitle className="sr-only">{item.label}</DialogTitle>
        <img src={item.src} alt={item.label} className="h-full w-full object-contain" />
        <button onClick={() => go(-1)} aria-label="Previous" data-testid="lightbox-prev" className="absolute left-4 top-1/2 grid h-12 w-12 -translate-y-1/2 place-items-center rounded-full bg-ivory text-ink"><ChevronLeft /></button>
        <button onClick={() => go(1)} aria-label="Next" data-testid="lightbox-next" className="absolute right-4 top-1/2 grid h-12 w-12 -translate-y-1/2 place-items-center rounded-full bg-ivory text-ink"><ChevronRight /></button>
        <p className="absolute bottom-6 left-1/2 -translate-x-1/2 font-mono text-xs uppercase tracking-[0.2em] text-ink">{item.label} · {idx + 1}/{items.length}</p>
      </DialogContent>
    </Dialog>
  );
};
